(ns ycweb.app.website.registry.close
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as cart-model]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.registry.common :as awr.cmn]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(defn- refresh-active-discontinued!
  "The registry-wide flag must follow the whole checkout list, not the item
   that was last parked or unparked."
  [process-atom]
  (swap! process-atom
    (fn [state]
      (assoc state :active-discontinued?
        (boolean
          (some #(get-in % [:item-line/variation :variation/discontinued-no-stock?])
            (vals (:checkout-items state))))))))

(defmethod grid/action :web.registry/close.unpark-item [app-atom config _]
  (toaster/open-toast app-atom :processing "Adding item" {:closetime 10000})
  (comms/ajax-post :web.registry/close.unpark-item config))

(defmethod comms/receive :web.registry/close.unpark-item [app-atom {:keys [success] :as unpark-response}]
  (toaster/close-toast app-atom)
  (cond
    success
    (let [process-atom (cmn/process-cursor app-atom)
          item (get-in @process-atom [:parked-items (:client-order-item/uuid unpark-response)])]

      (swap! process-atom yuc/dissoc-in [:parked-items (:client-order-item/uuid unpark-response)])
      (swap! process-atom assoc-in [:checkout-items (:client-order-item/uuid unpark-response)] item)
      (refresh-active-discontinued! process-atom)
      (toaster/open-toast app-atom :success "Item Added" {:closetime 2000}))

    :else
    (toaster/open-toast app-atom :error "Could not add item" {:closetime 2000})))

(defmethod grid/action :web.registry/close.park-item [app-atom config _]
  (toaster/open-toast app-atom :processing "Removing item" {:closetime 10000})
  (comms/ajax-post :web.registry/close.park-item config))

(defmethod comms/receive :web.registry/close.park-item [app-atom {:keys [success] :as park-response}]
  (toaster/close-toast app-atom)
  (cond
    success
    (let [process-atom (cmn/process-cursor app-atom)
          item (get-in @process-atom [:checkout-items (:client-order-item/uuid park-response)])]
      (swap! process-atom yuc/dissoc-in [:checkout-items (:client-order-item/uuid park-response)])
      (swap! process-atom assoc-in [:parked-items (:client-order-item/uuid park-response)] item)
      (refresh-active-discontinued! process-atom)
      (toaster/open-toast app-atom :success "Item removed" {:closetime 2000}))

    :else
    (toaster/open-toast app-atom :error "Could not remove item" {:closetime 2000})))

(rum/defc order-list-item < rum/reactive
  [app-atom item-action client-order-item]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom [:registry])
        remove? (= item-action :remove)

        {:item-line/keys [product variation]
         :client-order-item/keys [guest-messages price]} client-order-item

        {:guest-message/keys [guest-name]} (first guest-messages) ;This is list of messages because vouchers can be purchased by multiple people
        {:product/keys [voucher? link]} product
        {:variation/keys [out-of-stock? discontinued-no-stock? features]} variation]
    (when (not voucher?)
      [:tr.yc-tr
       {:key (:ent/uuid client-order-item)
        :class (yuc/bem :yc-tr [(when (or out-of-stock? discontinued-no-stock?) :warning)])}
       [:td
        {:class (yuc/bem :yc-td [:product-image])}
        [:a.block-link
         {:href link}
         (web-common/lazy-image app-atom
           (:doc/public-id (:ent/image variation))
           {:class ["yc-td__image"]}
           {:w 100
            :h 100
            :c "lpad"
            :q "auto"
            :alt ""})]]
       [:td
        {:class (yuc/bem :yc-td [:product-text])}
        [:a.block-link
         {:href link}
         [:div.yc-td__product-name (:ent/display-name product)]
         [:div.yc-td__product-description (yuc/presence features)]
         (when guest-name
           [:div.yc-td__product-notes
            [:span
             {:class (yuc/bem :text-status [:info])}
             (str "Purchased by " guest-name)]])]
        (cond
          discontinued-no-stock?
          [:div.yc-td__product-notes
           [:a
            {:on-click #(grid/dispatch-action app-atom :web.registry/item-discontinued-modal {})
             :class (yuc/bem :text-link [:negative])}
            "Discontinued item - Find out more."]]

          out-of-stock?
          [:div.yc-td__product-notes
           [:a
            {:on-click
             #(grid/open-modal app-atom :web.registry/purchase-list-out-of-stock-modal
                {:config
                 {:title "Item out of stock"}})
             :class (yuc/bem :text-link [:negative])
             :target_class "js-registry-item-out-of-stock"}
            "Item out of stock - Find out more."]])]
       [:td.yc-td
        [:span.yc-td__faux-table
         {:data-th "Price"}
         [:span.yc-td__faux-td (str "R" (yuc/currency-format price 2))]]]
       [:td
        {:class (yuc/bem :yc-td [:centered])}
        [:span.yc-td__faux-table
         {:data-th "Options"}
         (cond
           remove?
           [:span.yc-td__faux-td
            [:a.text-link
             {:on-click
              #(grid/dispatch-action app-atom :web.registry/close.park-item
                 {:registry/uuid (:ent/uuid registry)
                  :client-order-item/uuid (:ent/uuid client-order-item)})
              :class (yuc/bem :tooltip [:top])
              :data-tooltip "Remove"}
             [:i
              {:class
               (yuc/bem :icon [:inline :default :is-dark :delete])}]]]

           :else
           [:span.yc-td__faux-td
            (buttons/button-web "Add"
              {:on-click
               #(grid/dispatch-action app-atom :web.registry/close.unpark-item
                  {:registry/uuid (:ent/uuid registry)
                   :client-order-item/uuid (:ent/uuid client-order-item)})
               :style :primary
               :size :default})])]]])))

(rum/defc registry-checkout-items [app-atom client-order checkout-items parked-items]
  [:table
   {:id "registryordertableview"
    :class (yuc/bem :yc-table [:underline :order-view])}
   [:caption.yc-table-caption.hidden-from-view
    (str "Summary of your order " (:ent/display-name client-order))]
   [:colgroup [:col {:style {:width "140px"}}] [:col] [:col] [:col]]
   [:thead.yc-thead
    [:tr.yc-tr
     [:th.yc-th {:scope "col"} "Item"]
     [:th.yc-th {:scope "col"} "Description"]
     [:th.yc-th {:scope "col"} "Price"]
     [:th {:scope "col" :class (yuc/bem :yc-th [:centered])} "Options"]]]
   [:tbody.yc-tbody
    (map
      (fn [checkout-item]
        (rum/with-key
          (order-list-item app-atom :remove checkout-item)
          (str (:ent/uuid checkout-item))))
      checkout-items)
    (when (pos? (count parked-items))
      [:tr
       {:class (yuc/bem :yc-tr [:muted])}
       [:td
        {:class (yuc/bem :yc-td [:centered]), :colSpan "4"}
        [:span
         {:class (yuc/bem :text-status [:important])}
         [:b
          "Note: You have some items that weren't purchased by guests. "]
         [:a
          {:on-click #(scroll/scroll-to-id % "js-parked-items")
           :class (yuc/bem :text-link [:negative])}
          "View unbought items."]]]])]])

(rum/defc registry-park-items [app-atom parked-items]
  [:div.dashboard
   {:id "js-parked-items"}
   (headings/heading "Remaining Items"
     {:type :h3
      :size :small})
   [:table
    {:id "registryordertableview"
     :class (yuc/bem :yc-table [:order-view])}
    [:caption.yc-table-caption.hidden-from-view
     "Summary of your items remaining on your registry"]
    [:colgroup [:col {:style {:width "140px"}}] [:col] [:col] [:col]]
    [:thead.yc-thead
     [:tr.yc-tr
      [:th.yc-th {:scope "col"} "Item"]
      [:th.yc-th {:scope "col"} "Description"]
      [:th.yc-th {:scope "col"} "Price"]
      [:th {:scope "col" :class (yuc/bem :yc-th [:centered])} "Options"]]]
    [:tbody.yc-tbody
     (map
       (fn [item]
         (rum/with-key
           (order-list-item app-atom :add item)
           (str (:ent/uuid item))))
       parked-items)]]])

(rum/defc voucher-line < rum/reactive [guest-message]
  (let [{:guest-message/keys [guest-name total-price]} guest-message]
    [:tr.yc-tr
     [:td
      {:class (yuc/bem :yc-td [:product-text])}
      [:span.yc-td__faux-table
       {:data-th "Guest"}
       [:span.yc-td__faux-td guest-name]]]
     [:td.yc-td
      [:span.yc-td__faux-table
       {:data-th "Value"}
       [:span.yc-td__faux-td
        (str "R" (yuc/currency-format total-price))]]]]))

(rum/defc voucher-list-item < rum/reactive [client-order-item]
  (let [{:item-line/keys [product]
         :client-order-item/keys [guest-messages]} client-order-item
        {:product/keys [voucher?]} product]
    (when voucher?
      (map voucher-line guest-messages))))

(rum/defc registry-voucher-items [voucher-items]
  [:div.dashboard
   {:id "js-vouchers-purchased"}
   (headings/heading "Gift Vouchers Purchased"
     {:type :h3
      :size :small})
   [:table.yc-table
    [:caption.yc-table-caption.hidden-from-view
     "Summary of gift vouchers purchased for you buy your guests"]
    [:colgroup [:col {:style {:width "240px"}}] [:col]]
    [:thead.yc-thead
     [:tr.yc-tr
      [:th.yc-th {:scope "col"} "Guest"]
      [:th.yc-th {:scope "col"} "Voucher Value"]]]
    [:tbody.yc-tbody
     (map voucher-list-item voucher-items)]]])

(defmethod grid/action :web.registry/close.reopen [app-atom config _]
  (toaster/open-toast app-atom :processing "Reopening registry" {:closetime 10000})
  (comms/ajax-post :web.registry/close.reopen config))

(defmethod comms/receive :web.registry/close.reopen [app-atom {:keys [success] :as reopen-response}]
  (toaster/close-toast app-atom)
  (cond
    success
    (urlstate/redirect app-atom "registry" "edit" {:uuid (:registry/uuid reopen-response)})

    :else
    (toaster/open-toast app-atom :error "Could not reopen registry" {:closetime 2000})))

;; Close Registry Page
(rum/defc registry-close < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        {:registry/keys [past-close-date? payment-total pending-payment-total client-order] :as registry}
        (cmn/curact process-atom [:registry])

        payment-total (or payment-total 0)

        checkout-items
        (sort-by (comp :ent/display-name :item-line/product)
          (vals (cmn/curact process-atom [:checkout-items])))

        active-discontinued? (cmn/curact process-atom [:active-discontinued?])
        closing? (cmn/curact process-atom [:closing?])
        checkout-props (cmn/curact process-atom [:checkout-props])
        voucher-items (cmn/curact process-atom [:voucher-items])

        parked-items
        (sort-by (comp :ent/display-name :item-line/product)
          (vals (cmn/curact process-atom [:parked-items])))

        total-price (reduce + (map :client-order-item/total-price checkout-items))
        payment-difference (when (and total-price payment-total) (Math/abs (- total-price payment-total)))
        reopen-msg
        [:div
         [:p.yc-paragraph.u-max-width-720
          "Don't want to close just yet? You can "
          [:a.text-link
           {:on-click #(grid/dispatch-action app-atom :web.registry/close.reopen {:registry/uuid (:ent/uuid registry)})}
           "reopen your Registry"]
          "."]]]
    [:div
     {:class (yuc/bem :yc-page-content [:standard])}
     (awr.cmn/registry-manage-nav app-atom :close-view registry)
     [:div
      {:class (yuc/bem :dashboard [:s-t-margin])}
      (headings/heading
        [:span
         [:i
          {:class
           (yuc/bem :icon [:in-copy-left :inline :default :is-dark :gift])}]
         "Close" [:span.clip-text {:class (yuc/bem :unclip-text [:s])} " your"] " Registry"]
        {:type :h2
         :size :medium})

      (when
        (and checkout-items (pos? (count checkout-items)))
        [:div
         [:p.yc-paragraph.u-max-width-720
          (when past-close-date?
            (str "Congratulations. Now that your special day has come and gone it is time to finalise your registry" (when (and payment-total (pos? payment-total)) " so that you can receive your gifts") ". "))
          "Add or remove "
          [:b "items that you want to be checked out"]
          ". When you are happy with your selection, click \"Close & Checkout\" and you will be prompted to add your delivery details."]
         reopen-msg
         (headings/heading "Items to be checked out"
           {:type :h3
            :size :small})])

      (when
        (and pending-payment-total (pos? pending-payment-total))
        (feedback/feedback-raw :warning
          {:description
           (list
             [:b "Please note:"]
             (str " There are pending guest payments of R" (yuc/currency-format pending-payment-total) " that need to be cleared before you can close your registry."))
           :title "Pending Payments"}))

      (when active-discontinued?
        (feedback/feedback-raw :warning
          {:description
           (list
             [:b "Please note:"]
             (str " You have items that have recently been discontinued by our suppliers and we won't be able to get them for you. Because we are flexible and allow you to chop and change your gift selection before delivery, we cannot reserve the stock for you when it is bought by a guest. Please replace or remove those items to continue."))
           :title "Discontinued Products"}))

      (when
        (and voucher-items (pos? (count voucher-items)))
        (feedback/feedback-raw :info
          {:description
           ["Some of your guests chose to buy you a voucher instead of a gift. You can add another product to your list now, or close your registry and get a voucher to spend at a later date. "
            [:a.text-link
             (urlstate/href-on-click #(scroll/scroll-to-id % "js-vouchers-purchased"))
             "View your vouchers."]]
           :title "Gift Vouchers Purchased"}))

      (cond
        (and checkout-items (pos? (count checkout-items)))
        (registry-checkout-items app-atom client-order checkout-items parked-items)

        :else
        (cond
          (or (nil? payment-total) (zero? payment-total))
          [:div
           (feedback/feedback-raw :info
             {:description
              ["Unfortunately no purchases were made on your registry. You can choose to purchase some items off your registry and checkout as usual, or "
               [:a.text-link
                (urlstate/href-on-click #(grid/dispatch-action app-atom :web.registry/delete-registry-modal {:id "delete-registry-button"}))
                "delete your registry"] "."]})
           reopen-msg]
          :else
          [:div
           (feedback/feedback-raw :info
             {:description
              (str "You have R" (yuc/currency-format payment-difference 2) " to spend, add more items or redeem this amount in Yuppiechef Vouchers after checkout.")})
           reopen-msg]))]

     [:div
      {:class (yuc/bem :yc-section [:standard])}
      [:div.flex-grid-group
       (when
         (or
           (and checkout-items (pos? (count checkout-items)))
           payment-total)
         [:div
          {:class
           (yuc/bem :flex-grid-block [:ml-right :l-2-5 :ml-order-02 :ml-1-2])}
          [:div.flex-grid-content
           [:div.order-cost-summary
            [:div.order-cost__already-paid
             (str "Paid for by guests: R" (yuc/currency-format payment-total 2))
             (when (pos? (count voucher-items))
               [:span
                [:br]
                [:small "Including Gift Vouchers"]])]
            [:div.order-cost__total
             (str
               (if (< payment-total total-price)
                 "Total: R"
                 "Spending: R")
               (yuc/currency-format total-price 2))]
            [:div.order-cost__not-paid
             (cond
               (and payment-total total-price (< payment-total total-price))
               [:span.text-status--important
                (str "You'll need to pay in: R" (yuc/currency-format payment-difference 2))]

               (and payment-total total-price (> payment-total total-price))
               [:span
                [:span.text-status--important
                 (str "You still have R" (yuc/currency-format payment-difference 2) " to spend.")]
                [:br]
                [:small "Add more items or redeem in Yuppiechef Vouchers"]])]

            [:div.order-cost__button-wrapper
             (cond
               ;; Already closed: same link as My Account → Registries → Checkout
               checkout-props
               (buttons/button-web "Checkout"
                 (merge
                   {:href (str "/order.htm?action=ShowCart&cart_uuid=" (:cart_uuid checkout-props) "&p=" (:p checkout-props))}
                   {:style :primary
                    :size :default
                    :full true
                    :class :checkout-button}))

               (or
                 (and pending-payment-total (pos? pending-payment-total))
                 active-discontinued?
                 closing?)
               (buttons/button-web "Close & Checkout"
                 {:style :primary
                  :size :default
                  :disabled true
                  :full true
                  :class :checkout-button})

               (or (nil? checkout-items) (zero? (count checkout-items)))
               (buttons/button-web "Redeem Voucher"
                 {:on-click
                  #(grid/open-modal app-atom :web.registry/voucher-only-modal
                     {:config
                      {:title "Checkout Voucher Only"
                       :amount payment-difference
                       :uuid (:ent/uuid registry)}})
                  :style :primary
                  :size :default
                  :full true
                  :class :checkout-button})

               :else
               (buttons/button-web "Close & Checkout"
                 {:on-click #(grid/dispatch-action app-atom :web.registry/checkout {:uuid (:ent/uuid registry)})
                  :style :primary
                  :size :default
                  :full true
                  :class :checkout-button}))]]]])]]
     (when voucher-items
       (registry-voucher-items voucher-items))
     (when parked-items
       (registry-park-items app-atom parked-items))
     [:div.dashboard
      [:div.dashboard-footer.button-group
       (buttons/button-web "Add more gifts"
         (merge
           (urlstate/href-props app-atom "index")
           {:style :primary
            :size :small}))]]
     (toaster/loading-overlay app-atom :web.registry/close-checkout)]))

(defmethod flow/render-screen :web.registry/close [app-atom _]
  (website/screen-wrapper app-atom
    (registry-close app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/close [app-atom _ params]
  (toaster/open-overlay app-atom :web.registry/close-checkout)
  (comms/ajax-get :web.registry/close (select-keys params [:uuid])))

(defmethod comms/receive :web.registry/close
  [app-atom {:keys [registry checkout-items parked-items active-discontinued? voucher-items]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :registry registry
    :checkout-items checkout-items
    :parked-items parked-items
    :active-discontinued? active-discontinued?
    :voucher-items voucher-items)
  (toaster/close-overlay app-atom :web.registry/close-checkout))

(defmethod grid/action :web.registry/delete-registry-modal [app-atom config _]
  (grid/open-modal app-atom :web.registry/delete-registry-modal
    {:config
     {:title "Delete Registry"}}))

(defmethod grid/action :web.registry/checkout [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        mobile? (cmn/curact app-atom [:mobile?])
        registry @process-atom]
    (swap! process-atom assoc :closing? true)
    (toaster/open-toast app-atom :processing "Processing" {:closetime 500000})
    (comms/ajax-post :web.registry/checkout (assoc registry :mobile? mobile?))))

(defmethod comms/receive :web.registry/checkout
  [app-atom {:keys [error msg] :close-checkout/keys [order-id cart-uuid resume-props] :as response}]
  (if error
    (do
      (swap! (cmn/process-cursor app-atom)
        #(-> % (dissoc :closing?) (assoc :checkout-props resume-props)))
      (toaster/close-toast app-atom)
      (toaster/open-toast app-atom :error
        (or msg "Could not close your registry, please try again.")
        {:closetime 8000 :show-close-button true}))

    (do
      (yuc/set-cookie! app-atom :registry_orderid order-id)

      ;; Check if new cart feature is enabled and cart-uuid is present
      (let [new-cart-enabled? (cmn/curact app-atom [:features :new-cart])]
        (cond
          ;; New cart enabled and cart-uuid present - activate the cart
          (and new-cart-enabled? cart-uuid)
          (do
            (cart-model/set-cart-uuid app-atom cart-uuid)
            (toaster/close-toast app-atom)
            (urlstate/redirect! "/order.htm?action=ShowCart"))

          ;; Fallback to legacy behavior
          :else
          (urlstate/redirect app-atom "order" "ShowCart" {} true))))))

(defmethod grid/action :web.registry/close.delete [app-atom config _]
  (comms/ajax-post :web.registry/close.delete (select-keys config [:uuid])))

(defmethod comms/receive :web.registry/close.delete [app-atom {:keys [success feedback feedback-msg]}]
  (if (and success (not feedback))
    (urlstate/redirect app-atom "myaccount" "registry")
    (grid/open-modal app-atom :web.registry/registry-feedback-modal {:msg feedback-msg})))
